import { DashboardWidget, LayoutConfig } from "@sanity/dashboard";
import {
  DocumentListExporter,
  DocumentListExporterProps
} from "./DocumentListExporter";

export function documentListExporter<T>(
  config: { layout?: LayoutConfig } & DocumentListExporterProps<T>
): DashboardWidget {
  return {
    name: "document-list-exporter",
    component: (props) => (
      <DocumentListExporter
        query={config.query}
        referencedIdsQuery={config.referencedIdsQuery}
        title={config.title}
        mapResult={config.mapResult}
      />
    ),
    layout: config.layout ?? { width: "medium" }
  };
}
